module.exports = __webpack_public_path__ + "img/collection-icon.737b87fa.svg";